import clsx from "clsx"

type DividerProps = {
  readonly isBold?: boolean
  readonly orientation?: "horizontal" | "vertical"
  readonly className?: string
  readonly variant?: "secondary" | "silver" | "smoke"
}

// Partly inspired by: https://mui.com/material-ui/react-divider/
export function Divider({
  className,
  isBold = false,
  variant = "secondary",
  orientation = "vertical",
}: DividerProps) {
  function verticalClasses() {
    if (orientation !== "vertical") {
      return
    }

    return clsx(
      isBold ? "w-(--theme-grid-lg)" : "w-px",
      "top-0 -right-2 hidden h-full lg:block",
    )
  }

  function horizontalClasses() {
    if (orientation !== "horizontal") {
      return
    }

    return clsx(
      isBold ? "h-(--theme-grid-lg)" : "h-(--theme-grid-xs)",
      "inset-x-0 bottom-0 w-full",
    )
  }

  return (
    <hr
      className={clsx(
        className,
        verticalClasses(),
        horizontalClasses(),
        variant === "secondary" && "bg-grid-secondary",
        variant === "silver" && "bg-silver",
        variant === "smoke" && "bg-smoke",
        "absolute m-0! border-0",
      )}
    />
  )
}
